"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUuid = exports.defaultToAny = void 0;
var lodash_1 = require("lodash");
var defaultToAny = function (value) {
    var defaultValues = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        defaultValues[_i - 1] = arguments[_i];
    }
    return (0, lodash_1.reduce)(defaultValues, lodash_1.defaultTo, value);
};
exports.defaultToAny = defaultToAny;
var isUuid = function (uuid) {
    var v4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return v4Regex.test(uuid);
};
exports.isUuid = isUuid;
//# sourceMappingURL=Utility.js.map